import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=a64143a8&scoped=true&"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js&"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationLayout.vue?vue&type=style&index=0&id=a64143a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64143a8",
  null
  
)

export default component.exports